<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiTrashCan } from "@mdi/js";
export default {
  name: "MdiTrashCan",
  data() {
    return {
      svgPath: mdiTrashCan,
    };
  },
};
</script>
